// store/useTermsStore.ts
import { create } from "zustand";
import {
  type CreateLegalType,
  type LegalAttributeType,
  type LegalType,
  type PageTypes,
  pageTypesConst,
} from "@/types/entities/legal";
import dayjs from "dayjs";

interface LegalState {
  typeSelected: PageTypes;
  setType: (newType: PageTypes) => void;
  policies: LegalType[];
  setPolicies: (policies: LegalType[]) => void;
  terms: LegalType[];
  setTerms: (terms: LegalType[]) => void;
  selected: LegalAttributeType | CreateLegalType;
  setSelected: (legal: LegalAttributeType | CreateLegalType) => void;
  setDefault: () => void;
  isValid: boolean;
  setIsValid: (value: boolean) => void;
}

const defaultValue: LegalType | CreateLegalType = {
  content: "",
  active: true,
  version: 0,
  created_at: dayjs(new Date()).format("MM,DD,YYYY"),
  updated_at: dayjs(new Date()).format("MM,DD,YYYY"),
};

export const useLegalStore = create<LegalState>((set) => ({
  typeSelected: pageTypesConst.policies,
  setType: (newType: PageTypes) => set({ typeSelected: newType }),
  policies: [],
  setPolicies: (legals) => set({ policies: [...legals] }),
  selected: defaultValue,
  setSelected: (legal) => set({ selected: { ...legal } }),
  terms: [],
  setTerms: (legals) => set({ terms: [...legals] }),
  setDefault: () => set({ selected: defaultValue }),
  isValid: true,
  setIsValid: (value) => set({ isValid: value }),
}));
